import  {eXcell,__extends} from './eXcell';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlXCombo from '../../components/dhtmlXCombo';

var eXcell_combo = (function (_super) {
    __extends(eXcell_combo, _super);
    function eXcell_combo(a) {
        _super.call(this);
        if (!a) {
            return;
        }
        this.cell = a;
        this.grid = a.parentNode.grid;
        this._combo_pre = "";
    }
    eXcell_combo.prototype.edit = function () {
        if (!window.dhx_globalImgPath) {
            window.dhx_globalImgPath = this.grid.imgURL;
        }
        this.val = this.getValue();
        var c = this.getText();
        if (this.cell._clearCell) {
            c = "";
        }
        this.cell.innerHTML = "";
        if (!this.cell._brval) {
            this.combo = (this.grid._realfake
                ? this.grid._fake
                : this.grid)._col_combos[this.cell._cellIndex];
        }
        else {
            this.combo = this.cell._brval;
        }
        this.cell.appendChild(this.combo.DOMParent);
        this.combo.DOMParent.style.margin = "0";
        this.combo.DOMelem_input.focus();
        this.combo.setSize(this.cell.offsetWidth - 2);
        if (!this.combo._xml) {
            if (this.combo.getIndexByValue(this.cell.combo_value) != -1) {
                this.combo.selectOption(this.combo.getIndexByValue(this.cell.combo_value));
            }
            else {
                if (this.combo.getOptionByLabel(c)) {
                    this.combo.selectOption(this.combo.getIndexByValue(this.combo.getOptionByLabel(c).value));
                }
                else {
                    this.combo.setComboText(c);
                }
            }
        }
        else {
            this.combo.setComboText(c);
        }
        this.combo.openSelect();
    };
    eXcell_combo.prototype.selectComboOption = function (e, c) {
        c.selectOption(c.getIndexByValue(c.getOptionByLabel(e).value));
    };
    eXcell_combo.prototype.getValue = function () {
        return this.cell.combo_value || "";
    };
    eXcell_combo.prototype.getText = function () {
        var g = this.cell;
        if (this._combo_pre == "" && g.childNodes[1]) {
            g = g.childNodes[1];
        }
        else {
            g.childNodes[0].childNodes[1];
        }
        return dhx4.isIE ? g.innerText : g.textContent;
    };
    eXcell_combo.prototype.setValue = function (h) {
        if (typeof h == "object") {
            this.cell._brval = this.initCombo();
            var e = this.cell._cellIndex;
            var g = this.cell.parentNode.idd;
            if (!h.firstChild) {
                this.cell.combo_value = "&nbsp;";
                this.cell._clearCell = true;
            }
            else {
                this.cell.combo_value = h.firstChild.data;
            }
            this.setComboOptions(this.cell._brval, h, this.grid, e, g);
        }
        else {
            this.cell.combo_value = h;
            var c = null;
            if ((c = this.cell._brval) && typeof this.cell._brval == "object") {
                h = (c.getOption(h) || {}).text || h;
            }
            else {
                if ((c =
                    this.grid._col_combos[this.cell._cellIndex] ||
                        (this.grid._fake &&
                            (c = this.grid._fake._col_combos[this.cell._cellIndex])))) {
                    h = (c.getOption(h) || {}).text || h;
                }
            }
            if ((h || "").toString()._dhx_trim() == "") {
                h = null;
            }
            if (h !== null) {
                this.setComboCValue(h);
            }
            else {
                this.setComboCValue("&nbsp;", "");
                this.cell._clearCell = true;
            }
        }
    };
    eXcell_combo.prototype.detach = function () {
        var c = this.combo.getParent();
        if (c.parentNode == this.cell) {
            this.cell.removeChild(c);
        }
        else {
            return false;
        }
        var e = this.cell.combo_value;
        this.combo._confirmSelect("blur");
        if (!this.combo.getComboText() ||
            this.combo
                .getComboText()
                .toString()
                ._dhx_trim() == "") {
            this.setComboCValue("&nbsp;");
            this.cell._clearCell = true;
        }
        else {
            this.setComboCValue(this.combo
                .getComboText()
                .replace(/\&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;"), this.combo.getActualValue());
            this.cell._clearCell = false;
        }
        this.cell.combo_value = this.combo.getActualValue();
        this.combo.closeAll();
        this.grid._still_active = true;
        this.grid.setActive(1);
        return e != this.cell.combo_value;
    };
    eXcell_combo.prototype.initCombo = function (c) {
        var a = document.createElement("DIV");
        a.className = "dhxcombo_in_grid_parent";
        var g = this.grid.defVal[arguments.length ? c : this.cell._cellIndex];
       
        var h = new dhtmlXCombo(a, "combo", 0, g);
        if (this.grid.comboLoadFun[c] != null &&
            typeof this.grid.comboLoadFun[c] == "function") {
            this.grid.comboLoadFun[c](h);
        }
        this.grid.defVal[arguments.length ? c : this.cell._cellIndex] = "";
        var e = this.grid;
        h.DOMelem.onmousedown = h.DOMelem.onclick = function (l) {
            l = l || event;
            l.cancelBubble = true;
        };
        h.DOMelem.onselectstart = function (l) {
            l = l || event;
            l.cancelBubble = true;
            return true;
        };
        this.grid.attachEvent("onScroll", function () {
            if (h._isListVisible()) {
                h._hideList();
            }
        });
        h.attachEvent("onKeyPressed", function (l) {
            if (l == 13 || l == 27) {
                e.editStop();
                if (e._fake) {
                    e._fake.editStop();
                }
            }
        });
        return h;
    };
    eXcell_combo.prototype.fillColumnCombos = function (e, a) {
        if (!a) {
            return;
        }
        var g = dhx4.ajax.xmltop("rows", a, -1);
        if (g && g.tagName !== "DIV") {
            e.combo_columns = e.combo_columns || [];
            var columns = dhx4.ajax.xpath("//column", g);
            for (var c = 0; c < columns.length; c++) {
                if ((columns[c].getAttribute("type") || "").indexOf("combo") == 0) {
                    e.combo_columns[e.combo_columns.length] = c;
                    this.setComboOptions(e._col_combos[c], columns[c], e, c);
                }
            }
        }
    };
    eXcell_combo.prototype.setComboCValue = function (e, c) {
        if (this._combo_pre != "") {
            // var a = this.cell.offsetHeight ? this.cell.offsetHeight + "px" : 0;
            e =
                "<div style='width:100%;position:relative;height:100%;overflow:hidden;'>" +
                    this._combo_pre +
                    "<span>" +
                    e +
                    "</span></div>";
        }
        if (arguments.length > 1) {
            this.setCValue(e, c);
        }
        else {
            this.setCValue(e);
        }
    };
    eXcell_combo.prototype.setComboOptions = function (l, m, e, r, u) {
        if (window.dhx4.s2b(m.getAttribute("xmlcontent"))) {
            if (!m.getAttribute("source")) {
                var options = m.childNodes;
                var a = [];
                for (var n = 0; n < options.length; n++) {
                    if (options[n].tagName == "option") {
                        var g = options[n].firstChild ? options[n].firstChild.data : "";
                        a[a.length] = [
                            options[n].getAttribute("value"),
                            g,
                            options[n].getAttribute("css") || ""
                        ];
                    }
                }
                l.addOption(a);
                if (arguments.length == 4) {
                    e.forEachRowA(function (w) {
                        var v = e.cells(w, r);
                        if (!v.cell._brval && !v.cell._cellType && v.cell._cellIndex == r) {
                            if (v.cell.combo_value == "") {
                                v.setComboCValue("&nbsp;", "");
                            }
                            else {
                                if (!l.getOption(v.cell.combo_value)) {
                                    v.setComboCValue(v.cell.combo_value);
                                }
                                else {
                                    v.setComboCValue(l.getOption(v.cell.combo_value).text, v.cell.combo_value);
                                }
                            }
                        }
                    });
                }
                else {
                    var s = this.cell ? this : e.cells(u, r);
                    if (m.getAttribute("text")) {
                        if (m.getAttribute("text")._dhx_trim() == "") {
                            s.setComboCValue("&nbsp;", "");
                        }
                        else {
                            s.setComboCValue(m.getAttribute("text"));
                        }
                    }
                    else {
                        if (!s.cell.combo_value || s.cell.combo_value._dhx_trim() == "") {
                            s.setComboCValue("&nbsp;", "");
                        }
                        else {
                            if (!l.getOption(s.cell.combo_value)) {
                                s.setComboCValue(s.cell.combo_value);
                            }
                            else {
                                s.setComboCValue(l.getOption(s.cell.combo_value).text, s.cell.combo_value);
                            }
                        }
                    }
                }
            }
        }
        if (m.getAttribute("source")) {
            if (m.getAttribute("auto") &&
                window.dhx4.s2b(m.getAttribute("auto"))) {
                if (m.getAttribute("xmlcontent")) {
                    var sEl = this.cell ? this : e.cells(u, r);
                    if (m.getAttribute("text")) {
                        sEl.setComboCValue(m.getAttribute("text"));
                    }
                }
                else {
                    e.forEachRowA(function (y) {
                        var x = e.cells(y, r);
                        if (!x.cell._brval && !x.cell._cellType) {
                            var w = x.cell.combo_value.toString();
                            if (w.indexOf("^") != -1) {
                                var v = w.split("^");
                                x.cell.combo_value = v[0];
                                x.setComboCValue(v[1]);
                            }
                        }
                    });
                }
                l.enableFilteringMode(true, m.getAttribute("source"), window.dhx4.s2b(m.getAttribute("cache") || true), window.dhx4.s2b(m.getAttribute("sub") || false));
            }
            else {
                // var o = this;
                var h = arguments.length;
                l.load(m.getAttribute("source"), function () {
                    if (h == 4) {
                        e.forEachRow(function (x) {
                            var w = e.cells(x, r);
                            if (!w.cell._brval && !w.cell._cellType) {
                                if (l.getOption(w.cell.combo_value)) {
                                    w.setComboCValue(l.getOption(w.cell.combo_value).text, w.cell.combo_value);
                                }
                                else {
                                    if ((w.cell.combo_value || "").toString()._dhx_trim() == "") {
                                        w.setComboCValue("&nbsp;", "");
                                        w.cell._clearCell = true;
                                    }
                                    else {
                                        w.setComboCValue(w.cell.combo_value);
                                    }
                                }
                            }
                        });
                    }
                    else {
                        var v = e.cells(u, r);
                        if (l.getOption(v.cell.combo_value)) {
                            v.setComboCValue(l.getOption(v.cell.combo_value).text, v.cell.combo_value);
                        }
                        else {
                            v.setComboCValue(v.cell.combo_value);
                        }
                    }
                });
            }
        }
        if (!m.getAttribute("auto") ||
            !window.dhx4.s2b(m.getAttribute("auto"))) {
            if (m.getAttribute("editable") &&
                !window.dhx4.s2b(m.getAttribute("editable"))) {
                l.readonly(true);
            }
            if (m.getAttribute("filter") &&
                window.dhx4.s2b(m.getAttribute("filter"))) {
                l.enableFilteringMode(true);
            }
        }
    };
    eXcell_combo.prototype.getCellCombo = function () {
        if (this.cell._brval) {
            return this.cell._brval;
        }
        this.cell._brval = this.initCombo();
        return this.cell._brval;
    };
    eXcell_combo.prototype.refreshCell = function () {
        this.setValue(this.getValue());
    };
    return eXcell_combo;
})(eXcell);
window.eXcell_combo = eXcell_combo;
export default eXcell_combo;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_combo.js